import { type JSONData } from "../../base_classes/dto.d";
import { MediaDto } from "./dto.gen";
import { type IMedia } from "./entity.d";
import MediaParsers from "./parsers";
import MediaValidators from "./custom_validators";
import { uploadFile } from "@/firebase/upload";

export class Media extends MediaDto implements IMedia {
  constructor(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        },
    data?: JSONData,
  ) {
    super(data, MediaParsers, MediaValidators);

    if (data !== undefined) {
      // Set data
      this.set(data);
    }

    this.buildPathObject(pathVars);
  }
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  public async get(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        }
      | undefined,
  ): Promise<Media> {
    return (await super.get(pathVars)) as Media;
  }

  async getImageSize(): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = (err) => {
        reject(err);
      };
      img.src = this.url;
    });
  }

  /// ///////////////////////////////////////
  /// /////////// STATIC METHODS ////////////
  /// ///////////////////////////////////////

  static override FromJSON(data?: JSONData): Media {
    return new Media(undefined, data);
  }

  static override FromJSONArray(data: JSONData[]): Media[] {
    return data.map((item) => Media.FromJSON(item));
  }

  static FromDto(dto: MediaDto): Media {
    return new Media(undefined, dto.toJSON());
  }

  public static async Create(file: File): Promise<Media> {
    // Upload the file to Firebase Storage
    const { id, extension, size, url, storagePath, mimeType } =
      await uploadFile(file);

    // Create the Media object
    const media = new Media(id, {
      id,
      extension,
      url,
      size,
      storagePath: storagePath,
      mimeType: mimeType,
    });

    // Save the Media object
    await media.update(id);

    // Return the Media object
    return media;
  }
}
